import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-676489e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "预算中台", -1))
const _hoisted_4 = { class: "user-btn" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_deployment_unit_outlined = _resolveComponent("deployment-unit-outlined")!
  const _component_nestable_menu_item = _resolveComponent("nestable-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_user_outlined = _resolveComponent("user-outlined")!
  const _component_login_outlined = _resolveComponent("login-outlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "main-view" }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_spin, {
              size: "large",
              tip: "系统数据加载中..."
            })
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_a_layout_sider, {
              collapsible: "",
              collapsed: _ctx.collapsed,
              "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collapsed) = $event)),
              trigger: null
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["logo", { collapsed: _ctx.collapsed }])
                }, [
                  _createElementVNode("span", _hoisted_2, [
                    _createVNode(_component_deployment_unit_outlined)
                  ]),
                  _hoisted_3
                ], 2),
                _createVNode(_component_a_menu, {
                  theme: "dark",
                  mode: "inline",
                  openKeys: _ctx.menu.openKeys,
                  "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menu.openKeys) = $event)),
                  selectedKeys: _ctx.menu.selectedKeys,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.menu.selectedKeys) = $event)),
                  onSelect: _ctx.onMenuSelect
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu.items, (item) => {
                      return (_openBlock(), _createBlock(_component_nestable_menu_item, _mergeProps({
                        key: item.id
                      }, item), null, 16))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["openKeys", "selectedKeys", "onSelect"])
              ]),
              _: 1
            }, 8, ["collapsed"]),
            _createVNode(_component_a_layout, { class: "main-right" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_header, { class: "top-bar" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.collapsed ? 'MenuUnfoldOutlined' : 'MenuFoldOutlined'), {
                      class: "trigger",
                      onClick: _ctx.onToggle
                    }, null, 8, ["onClick"])),
                    _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                      overlay: _withCtx(() => [
                        _createVNode(_component_a_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_menu_item, { onClick: _ctx.onLogout }, {
                              default: _withCtx(() => [
                                _createVNode(_component_login_outlined),
                                _hoisted_6
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_user_outlined),
                          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.username), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_layout_content, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
    ]),
    _: 1
  }))
}